import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClClickAwayListener from '../ClClickAwayListener';
import ClSnackbarContent from '../ClSnackbarContent';
import ClSlide from '../ClSlide';

type AnchorOrigin = {
  vertical: 'top' | 'center' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
};

export type Color =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'warning'
  | 'error'
  | 'success';

@Component({
  components: {
    ClSnackbarContent,
    ClClickAwayListener,
    ClSlide
  }
})
export default class ClSnackbar extends Vue {
  @Prop({
    type: Object as () => AnchorOrigin,
    default: () => ({
      vertical: 'bottom',
      horizontal: 'center'
    })
  })
  public anchorOrigin!: AnchorOrigin;

  @Prop({
    type: Number
  })
  public autoHideDuration!: number | null | undefined;

  @Prop({
    type: Object,
    default: () => ({})
  })
  public ClClickAwayListenerProps!: object;

  @Prop({
    type: String as () => Color,
    default: 'default'
  })
  public color!: Color;

  @Prop({
    type: Boolean
  })
  public open!: boolean;

  @Prop({
    type: String
  })
  public message!: string;

  private timerAutoHide?: number;

  handleClickAway(event: Event) {
    this.$emit('click-away', event);
  }

  created() {
    if (this.autoHideDuration) {
      this.setAutoHideTimer(this.autoHideDuration);
    }
  }

  @Watch('open')
  onOpenChange(newValue: boolean) {
    if (newValue === true) {
      if (this.autoHideDuration) {
        this.setAutoHideTimer(this.autoHideDuration);
      }
    }
  }

  @Watch('autoHideDuration')
  onAutoHideDurationChange(newValue: number) {
    if (newValue) {
      this.setAutoHideTimer(newValue);
    }
  }

  handlePause() {
    window.clearTimeout(this.timerAutoHide);
  }

  handleResume() {
    if (this.autoHideDuration) {
      this.setAutoHideTimer(this.autoHideDuration * 0.5);
    }
  }

  setAutoHideTimer(duration: number) {
    window.clearTimeout(this.timerAutoHide);
    this.timerAutoHide = window.setTimeout(() => {
      this.$emit('close', null, 'timeout');
    }, duration);
  }

  handleMouseEnter(event: Event) {
    this.$emit('mouseenter', event);
    this.handlePause();
  }

  handleMouseLeave(event: Event) {
    this.$emit('mouseleave', event);
    this.handleResume();
  }
}
